import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { ReplaySubject } from 'rxjs/ReplaySubject'

import { Operador } from '../../pkw-data/core/operador.model'

import { Base64 } from 'js-base64'
import { PkwDatastoreIdentificacao } from '../../pkw-data/pkw-datastore-identificacao'

@Injectable()
export class OperadorService {
    corrente: Observable<Operador>

    private _corrente: ReplaySubject<Operador>

    constructor(private pkwDatastoreIdentificacao: PkwDatastoreIdentificacao) {
        this._corrente = new ReplaySubject<Operador>(1)
        this.corrente = this._corrente.asObservable()
    }

    obterCorrente() {
        const userData = this.parseJwt()
        return this.pkwDatastoreIdentificacao
            .findRecord(Operador, 'eu', {
                include: 'foto'
            })
            .map((operador) => {
                this._corrente.next(operador)
                operador.crm = userData.crm
                return operador
            })
    }

    parseJwt() {
        let cookies = document.cookie.split('jwt=')
        cookies = cookies[1].split(';')
        const jwt = cookies[0]
        try {
            return JSON.parse(Base64.decode(jwt.split('.')[1]))
        } catch (e) {
            return null
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/operador.service.ts